import React from "react";
import { FormattedDate } from "react-intl";

import { Hero } from "./hero";
import { Block } from "./block";
import { Navigation } from "./navigation";
import TitleLayers from "./titleLayers";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

import styles from "./styles.modules.scss";
import { CrcokArticleView } from "./crcok";
import { saveContentfulItems } from "../../utils/save-contentful-items";

const ADD_TITLE_LAYERS = window.GAMENAME === "squadbusters";

export type ArticleType = {
    article: InboxArticle;
    Link: (props: unknown) => JSX.Element;
    prevLinkProps?: Record<string, unknown>;
    nextLinkProps?: Record<string, unknown>;
    shouldAnimate?: boolean;
};

export const Article = (props: ArticleType) => {
    const loc = useLocation();
    const { pathname } = loc;

    saveContentfulItems("article", [props.article]);

    useEffect(() => {
        window.scrollTo(0, 0);

        const article = document.querySelector(".article");

        if (article) {
            article.scrollTo(0, 0);
        }
    }, [pathname]);

    if (props.article?.targeting?.campaignId === "crcok") {
        return <CrcokArticleView article={props.article} />;
    }

    return <ArticleView {...props} />;
};

export const ArticleView = ({
    article,
    Link,
    prevLinkProps,
    nextLinkProps,
    shouldAnimate = false,
}: ArticleType) => {
    React.useEffect(() => {
        document.querySelector(".app")?.scrollTo(0, 0);
        document.querySelector("#inbox")?.scrollTo(0, 0);
    }, [article?.id]);

    if (!article) return null;

    const {
        title,
        heroImage,
        categories,
        postDate,
        hideTitle,
        details,
        targeting,
    } = article;

    const style = {
        "--heroBackground": categories[0]?.color,
    } as React.CSSProperties;

    return (
        <div
            className={`article content ${styles.article} ${
                targeting?.campaignId ?? ""
            } `}
        >
            <div className="header">
                <Hero image={heroImage} />
            </div>

            <div className={`body ${styles.body}`}>
                <div
                    className={`title-container ${styles.titleContainer}`}
                    style={style}
                >
                    <div className={`meta ${styles.meta}`}>
                        <div className={`categories ${styles.categories}`}>
                            {categories.map(({ title, color }) => {
                                const style = {
                                    "--categoryColor": color,
                                } as React.CSSProperties;

                                return (
                                    <div
                                        key={title}
                                        className={`category ${styles.category} ${title}`}
                                        style={style}
                                    >
                                        {title}
                                    </div>
                                );
                            })}
                        </div>

                        <div className={`date ${styles.date}`}>
                            <FormattedDate
                                value={postDate}
                                month="long"
                                day="numeric"
                            />
                        </div>
                    </div>

                    {!hideTitle && (
                        <div className={`title-wrapper`}>
                            {ADD_TITLE_LAYERS ? (
                                // This is a solution to build the Squadbusters title
                                <TitleLayers title={title} styles={styles} />
                            ) : (
                                <div
                                    className={`title ${styles.title}`}
                                    data-title={title}
                                >
                                    {title}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className={`details ${styles.details}`}>
                    {(details || []).map((detail, index) => {
                        return (
                            <Block
                                key={index}
                                campaignId={targeting?.campaignId}
                                {...detail}
                            />
                        );
                    })}
                </div>
            </div>

            <div className={`footer ${styles.footer}`}>
                <Navigation
                    Link={Link}
                    prevLinkProps={prevLinkProps}
                    nextLinkProps={nextLinkProps}
                    shouldAnimate={shouldAnimate}
                />
            </div>
        </div>
    );
};
